var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalochka(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick 1",
    clipPath: "url(#clip0_869_1884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-in"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Textfields"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email-Address"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M17.7364 0.269225C17.3849 -0.0897418 16.8151 -0.0897418 16.4636 0.269225L5.68107 11.2812L1.53642 7.04842C1.18496 6.68945 0.615146 6.68949 0.263619 7.04842C-0.087873 7.40735 -0.087873 7.98929 0.263619 8.34825L5.04466 13.2309C5.39601 13.5898 5.96624 13.5896 6.31745 13.2309L17.7364 1.56909C18.0879 1.21016 18.0879 0.628193 17.7364 0.269225Z",
    fill: "#2B47FC"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_869_1884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalochka);
export default __webpack_public_path__ + "static/media/galochka.d55b5688e8a325d31fae5dfa61df373a.svg";
export { ForwardRef as ReactComponent };